// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"AddDevicePage_pageContainer__OOR_j","secondaryPageContainer":"AddDevicePage_secondaryPageContainer__1URAR"};